export default (sorted = []) => sorted.reduce((arr, { id, desc }) => [...arr, ...id.split('|').map((id) => `${id} ${desc ? 'desc' : 'asc'}`)], [])